/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Fragment, useCallback, useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  alertMessage,
} from "../../common/Common";
import I18n from "../../common/I18n";
import { checkServiceExistance, normalizeCompanyColumns,  normalizeLegColumns, ensureLegColumnsInOrder, toScreenConfigFormat } from "../../helpers/common";
import MyGridComponent from "./ReactDataGrid";
import { checkboxColumn, getDispatchCols,getPrePlanCol , getOrderListCols  } from "../common/columnDefs";
import { setGridConfigSetting } from "../../api/DisplaySettings";
import { getConfiguredColumns, getStoredColumns, ensureLegLevelColumns } from "../orders/helpers";
import { ScreenKeys } from "../../containers/constants";


const UnallocatedOrdersGridList = (props) => {

  const { rawDataSource, accountCodesWithExceededLimit, userContext, tableName, addDropZones } = props;
  const { updateColWidths, currentUser } = userContext || {};
  const isCLIEnabled = userContext?.orgRules?.org_billing_rules?.cli_order_types === 'true';
  const [ filteredRowData, setFilteredRowData ] = useState([]);
  // const dispatchCols = getDispatchCols(props);
  // const [ columnDefs, setColumnDefs ] = useState(dispatchCols);
  const tableColMapping = {
    [ScreenKeys.DISPATCH.UNASSIGNED_ORDERS_V2]: getDispatchCols({...props, isCLIEnabled}),
    [ScreenKeys.ORDER_LISTING_V2]: getOrderListCols({...props, isCLIEnabled}),
    [ScreenKeys.PREPLAN.UNASSIGNED_ORDERS]: getPrePlanCol({...props, isCLIEnabled})
  };

  const allCols = _.get(tableColMapping, tableName, []);
  const [ columnDefs, setColumnDefs ] = useState(allCols);


  useEffect(() => {
    const modifiedData = rawDataSource?.map((order) => {
      const pickupLocation = order?.locations?.find((location) => location.type_of_loc === "PICKUP");
      const deliveryLocation = order?.locations?.find((location) => location.type_of_loc === "DELIVERY");
      const normalizedOrder = {
        ...order,
        pickup_location_id: pickupLocation?.id || null,
        delivery_location_id: deliveryLocation?.id || null,
      };

      if (accountCodesWithExceededLimit.includes(order.account_code)) {
        return {
          ...normalizedOrder,
          account_limit_exceeded: true
        };
      } else {
        return normalizedOrder;
      }
    });
    setFilteredRowData(modifiedData);
  }, [ rawDataSource, accountCodesWithExceededLimit ]);

  const ProcessCols = () => {
    const columns = [];
    const hasSomeConfiguration = props.displayConfiguration && (props.displayConfiguration.userConfiguration || props.displayConfiguration.orgConfiguration);
    const storedColumns = getStoredColumns(currentUser, tableName);

    if (!hasSomeConfiguration) {
      columns.push(...allCols);
    } else {
      const { userConfiguration = {} } = props.displayConfiguration;
      const { orgConfiguration = {} } = props.displayConfiguration;
      columns.push(...getConfiguredColumns(allCols, storedColumns, userConfiguration, orgConfiguration, tableName));
    }
    const columnsWithLegs = ensureLegLevelColumns(columns, allCols, props.organizationSettings);
    setColumnDefs(columnsWithLegs);
  };

  useEffect(() => {
    ProcessCols();
  }, [
    rawDataSource,
    props.displayConfiguration,
    props.vhTypes,
    props.organizationSettings,
    tableName,
    currentUser,
  ]);

  const handleSaveColumnWidth = ({ colId, newWidth, colState }) => {
    let newColumnDefs = [];
    colState.forEach((col) => {
      if (col.colId === '0') {
        newColumnDefs.push(checkboxColumn);
      }
      else if (col.colId === 'items') {
        newColumnDefs.push(itemsColdef);
      }
      else {
        const foundCol = _.find(columnDefs, { field: col.colId });
        newColumnDefs.push({ ...foundCol, width: col.width });
      }
    }
    );
    setColumnDefs(newColumnDefs);

    const finalColumnDefs = colState.map((col) => { return { key: col.colId, width: col.width }; });
    updateColWidths(tableName, toScreenConfigFormat(finalColumnDefs));
  };

  const handleSaveRowIdx = useCallback((colState) => {
    let newOrder = _.compact(colState
      .filter((col) => col.isVisible) // filter out columns where isVisible is false
      .map((col) => col.field || col.colId));    
    const { currentUser } = userContext;
    let orderedColumns = normalizeCompanyColumns(newOrder);
    orderedColumns = normalizeLegColumns(orderedColumns);
    orderedColumns = ensureLegColumnsInOrder(orderedColumns, props.organizationSettings);

    if(!currentUser) return;
    const { _id: userId, currentOrg } = currentUser;
    const data = {
      organization_id: currentOrg._id,
      config_type: tableName,
      config_value: orderedColumns,
      user_id: userId
    };
    setGridConfigSetting(data).then((result) => {
      if (result.success) {
        props.dispContext("userConfiguration", {
          ...props.displayConfiguration.userConfiguration,
          [tableName]: [...orderedColumns],
        });
        alertMessage(I18n.t("messages.saved"), "success", 10);
      } else {
        alertMessage(result.errors[0], "error", 10);
      }
    }
    );

  }, [ tableName ]);


  const handleSaveColIdx = useCallback((colState) => {
    let newOrder = _.compact(colState
      .filter((col) => !col.hide) // filter out columns where isVisible is false
      .map((col) => col.field || col.colId));
    const { currentUser } = userContext;
    const { _id: userId, currentOrg } = currentUser;
    let orderedColumns = normalizeCompanyColumns(newOrder);
    orderedColumns = normalizeLegColumns(orderedColumns);
    orderedColumns = ensureLegColumnsInOrder(orderedColumns, props.organizationSettings);

    const data = {
      organization_id: currentOrg._id,
      config_type: tableName,
      config_value: orderedColumns,
      user_id: userId
    };
    setGridConfigSetting(data).then((result) => {
      if (result.success) {
        props.dispContext("userConfiguration", {
          ...props.displayConfiguration.userConfiguration,
          [tableName]: [...orderedColumns],
        });
        alertMessage(I18n.t("messages.saved"), "success", 10);
      } else {
        alertMessage(result.errors[0], "error", 10);
      }
    }
    )
  }
    , [ tableName, props.organizationSettings ]);

  const handleRowChecked = (colId, checked) => {
    const newColumnDefs = columnDefs.map((col) => {
      if (col.field || col.colId === colId) {
        return { ...col, hide: !checked };
      }
      return col;
    });
    setColumnDefs(newColumnDefs);
  };

  return (
    <MyGridComponent
      columnDefs={ columnDefs }
      rowData={ filteredRowData }
      onRowSelection={props.onRowSelection}
      onSortChanged={ (colState) => {
        const sortedCol = colState[ 0 ];
        const { colId, sort } = sortedCol; props.onSort(colId, sort);
      }
      }
      addDropZones={addDropZones}
      totalCols={ allCols }
      saveColumnWidth={ handleSaveColumnWidth }
      onColumnMoved={ handleSaveColIdx }
      onRowMoved={ handleSaveRowIdx}
      // setCurrentGridRef={ props.setCurrentGridRef }
      onGridReady={ props.onGridReady }
      {...(typeof props.onFilterChanged === "function" ? { onFilterChanged: props.onFilterChanged } : {})}
      handleColumnVisibilityChange={props.handleColumnVisibilityChange}
      showRerraangeModal={props.showRerrangeableModal}
      closeModal={ props.closeModal }
      isRowSelectable={ props.isRowSelectable }
      handleRowSelection={ handleRowChecked }
      selectedIds={ props.selectedIds }
      source={props.source}
      loading={props.loading}
    />
  );
};


export default UnallocatedOrdersGridList;

UnallocatedOrdersGridList.propTypes = {
  rawDataSource: PropTypes.array,
  accountCodesWithExceededLimit: PropTypes.array,
  userContext: PropTypes.object,
  tableName: PropTypes.string,
  onRowSelection: PropTypes.func,
  onSort: PropTypes.func,
  vhTypes: PropTypes.array,
  displayConfiguration: PropTypes.object,
  organizationSettings: PropTypes.object,
  accountsList: PropTypes.array,
  zonesList: PropTypes.array,
  handleColumnVisibilityChange: PropTypes.func,
  modalOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  isRowSelectable: PropTypes.func,
  source : PropTypes.string,
  addDropZones: PropTypes.func
};

UnallocatedOrdersGridList.defaultProps = {
  rawDataSource: [],
  accountCodesWithExceededLimit: [],
  userContext: {},
  tableName: '',
  onSort: () => { },
  vhTypes: [],
  displayConfiguration: {},
  organizationSettings: {},
  accountsList: [],
  zonesList: [],
  handleColumnVisibilityChange: () => { },
  modalOpen: false,
  closeModal: () => { },
  isRowSelectable: () => { },
  source : null,
  loading : false,
  addDropZones: () => {}
};